import { FC } from "react";
import NewsListItem from "@modules/for-you/components/NewsListItem";
import LoadingIndicator from "@common/components/LoadingIndicator";
import { useNewsList } from "@modules/for-you/hooks";
import { Typography } from "@earned/core";

const NewsList: FC = () => {
  const { isLoading, newsItems } = useNewsList();

  return (
    <div className="lg:max-w-[280px]">
      <div className="flex flex-row gap-2 border-b border-primary pb-[34px]">
        <Typography variant="body-xl" weight="medium" color="primary">
          Relevant News
        </Typography>
        <Typography variant="body-xl" color="primary">
          For You
        </Typography>
      </div>
      <div className="grid auto-rows-auto grid-cols-[repeat(auto-fit,_minmax(210px,_1fr))] gap-5 py-6">
        {isLoading ? (
          <LoadingIndicator isVisible />
        ) : (
          newsItems.map((newsItem) => (
            <NewsListItem key={newsItem.ID} newsItem={newsItem} />
          ))
        )}
      </div>
    </div>
  );
};

export default NewsList;
